<template>
  <inertia-head>
    <title>{{seo.page_title}}</title>
    <meta name="title" :content="`${seo.page_title}`"/>
    <meta name="description" :content="`${textShorter(seo.page_description)}`"/>
    <meta name="keywords" :content="`${seo.key_words}`"/>
    <meta property="og:title" :content="`${seo.page_title}`"/>
    <meta property="og:description" :content="`${textShorter(seo.page_description)}`"/>
    <meta name="twitter:title" :content="`${seo.page_title}`">
    <link v-if="!seo.canonical_tag" rel="canonical" :href="canonicalLink"/>
    <link v-else rel="canonical" :href="`${seo.canonical_tag}`"/>
    <meta v-if="seo.noindex_tag" name="robots" :content="`${seo.noindex_tag}`"/>
  </inertia-head>

  <loading :show="loading"/>

  <div class="bg-fixed bg-no-repeat bg-center"
       :style="`height: 85vh; background-size: cover; background-image: url(${$page.props.configs.mainPageBanner})`">

    <Header :navigation_show="navigation" @navigation="updateNavigation"/>

    <main v-on:click="navigation=false" class="container container-lg mx-auto mb-6" style="padding-top: 35px !important;">
      <span v-if="userRegisterGoogleAds && userRegisterGoogleAds == 2" id="google_ads_user_register_from_sign_up" class="google_ads_user_register_from_sign_up"></span>

      <h1 class="text-center md:pt-16 pt-12">
        <span class="text-white text-xl sm:text-5xl drop-shadow-xl block">Find the best online trainer</span>
        <span class="text-white text-2xl font-weight-bold mt-4 sm:text-7xl drop-shadow-xl block">to live healthy & happy</span>
      </h1>


      <div class="text-center place-items-center mt-12 sm:mt-20 mx-5 sm:mx-auto max-w-screen-sm relative">
        <div class="px-2 p-1 bg-white border w-40 rounded-full text-lg mx-auto mt-3 absolute z-10 -top-8 inset-x-0">
          Explore By:
        </div>
        <div class="p-3 mt-4 mx-auto border-white border bg-white justify-self-center shadow-lg rounded-2xl backdrop-saturate-100 bg-opacity-30 backdrop-filter backdrop-blur-xl drop-shadow-md">
          <div class="flex flex-col mt-5">
              <span class="text-white text-lg">Speciality</span>
              <select v-model="categorySelected"
                      @change="toMaster()"
                      class="rounded-full bg-white border-none focus:bg-indigo-100 mt-3 p-2 text-center w-full sm:w-[75%] mx-auto ">
                <option value="null" class="text-opacity-60">Choose</option>
                  <option v-for="speciality in $page.props.categories"
                          :key="speciality.id"
                          :value="speciality.url"
                          class="text-opacity-60">{{ speciality.title }}
                  </option>
              </select>
            <!--                            <div class="col-span-6 sm:col-span-2 grid flex-grow w-full">-->
            <!--                                <span class="text-white text-lg">Price</span>-->
            <!--                                <select class="rounded-full bg-white border-none focus:bg-indigo-100 mt-2 p-2">-->
            <!--                                    <option class="text-opacity-60">Choose</option>-->
            <!--                                </select>-->
            <!--                            </div>-->
            <!-- <div class="col-span-6 sm:col-span-3 flex-shrink w-full">
              <button @click="toMaster()" type="button"
                      :disabled="!categorySelected"
                      class="custom-button bg-yellow-400 text-lg shadow-md sm:mt-9 px-3 py-1 ml-3 rounded-full text-white hover:shadow-xl transition duration-500 ease-in-out hover:bg-yellow-500 focus:ring focus:ring-yellow-500"
              >Show the trainers
              </button>
            </div> -->
          </div>
        </div>
      </div>


      <div class="text-center place-items-center mt-12 sm:mt-20 mx-5 sm:mx-auto max-w-screen-xl relative">
        <div class="px-2 py-2 bg-green-500 text-white border w-64 rounded-full text-xl mx-auto mt-3 absolute z-10 -top-8 inset-x-0">
          Popular Specialities
        </div>
        <div class="h-74 grid gap-0 md:grid-cols-2 lg:grid-cols-3 bg-white rounded-2xl md:mx-3 shadow-md h-auto">
          <div v-for="(category,key) in categories" :key="key">
            <Link :key="key"
                  :href="`/${category.url}/online`"
                  v-show="(isMobile() ? key<6 : key<8) || showAllService"
                  :style="!isMobile() ? 'height: 7rem' : ''"
                  class="p-3 sm:flex grid w-full h-full border-none pt-6 "
                  :class="(key===0 ? 'rounded-tl-2xl rounded-tr-2xl md:rounded-tr-none ' : '')
                                      /*|| (key===3 ? 'sm:rounded-tr-2xl' : '')*/
                                       || (
                                           typeof evenNumber === 'function' &&
                                           (
                                               (evenNumber(key) && key===2 ? 'sm:rounded-tr-2xl sm:rounded-none' :  '')
                                              || (evenNumber(key) && key=== categories.length - 1 ? 'rounded-bl-2xl' :  '')
                                              || (!evenNumber(key) && key=== categories.length - 1 ? 'rounded-br-2xl' :  '')
                                               || ((evenNumber(key) && categories.length===3 && key===2 ) ? 'rounded-b-2xl' : '')
                                           )
                                       )">
              <div class="flex-wrap self-center mx-auto">
                <img class="w-16" :alt="category.title" :src="`uploads/${category.image_url}`" width="64" height="64">
              </div>
              <div class="grid flex-1 self-center">
                <div>
                  <span class="text-2xl sm:text-xl text-gray-500 whitespace-pre capitalize">{{ category.title }}</span>
                </div>
                <div>
                  <span>{{ category.master_speciality_count }} Trainers</span>
                </div>
              </div>
            </Link>
          </div>
          <div v-if="categories.length>6" class="order-start text-left items-center flex py-3 pl-3 cursor-pointer" @click="showAllService=!showAllService">
            <span v-if="!showAllService" class="material-icons text-green-500 mr-1">arrow_drop_down_circle</span>
            <span v-if="showAllService" class="material-icons text-green-500 mr-1">arrow_circle_up</span>
            <p>Show more</p>
          </div>
        </div>
      </div>

      <section v-for="option in options" v-show="option.key!=='MAIN_PAGE_OPTIONS_S3'"
               class="rounded-2xl shadow-xl bg-white p-9 border mx-2 mt-10 sm:mx-auto max-w-screen-xl">

        <h2 class="sm:text-5xl text-xl text-center py-3">{{ JSON.parse(option.value).SECTION_TITLE }}</h2>

        <p class="sm:text-3xl text-lg text-center py-3 text-gray-400">{{ JSON.parse(option.value).SECTION_SUB_TITLE }} </p>

        <div class="sm:p-4 grid md:grid grid-cols-6 md:grid-cols-6 gap-6">
          <div v-for="(item,key) in JSON.parse(option.value)['option_title']" class="col-span-6 sm:col-span-2">
            <div class="px-4 text-center">

              <div class="w-full flex items-center justify-center" style="height: 300px">
                <img :alt="item" class=""
                     :src="`${JSON.parse(option.value)['option_pic'][key]}`" width="300" height="300">
              </div>

              <h4 class="sm:text-2xl text-xl mt-3">{{ item }}</h4>

              <p class="text-gray-700 whitespace-normal mt-3"
                 v-html="JSON.parse(option.value)['option_body'][key]">
              </p>
            </div>
          </div>
        </div>
      </section>

      <section v-show="options.find(i=>i.key==='MAIN_PAGE_OPTIONS_S3')"
               class="text-center place-items-center mt-12 sm:mt-20 mx-2 sm:mx-auto max-w-screen-xl relative">

        <h2 class="px-2 py-2 bg-green-500 text-white border w-64 rounded-full text-xl mx-auto mt-3 absolute z-10 -top-8 inset-x-0">
          {{ JSON.parse(options.find(i => i.key === 'MAIN_PAGE_OPTIONS_S3').value).SECTION_TITLE }}
        </h2>

        <div class="rounded-2xl shadow-xl bg-white p-9 border mt-10 max-w-screen-xl">
          <p class="text-gray-700 text-justify mt-4"
             v-html="JSON.parse(options.find(i=>i.key==='MAIN_PAGE_OPTIONS_S3').value).option_body"></p>
        </div>
      </section>

      <article class="text-center place-items-center mt-12 sm:mt-20 mx-2 sm:mx-auto max-w-screen-xl relative">
        <div class="px-2 py-2 bg-green-500 text-white border w-64 rounded-full text-xl mx-auto mt-3 absolute z-10 -top-8 inset-x-0">
          FAQ
        </div>

        <div class="rounded-2xl shadow-xl bg-white sm:p-9 p-2 pt-9  border mt-10 max-w-screen-xl">
          <div v-for="(item,key) in faqs" class="mt-2">
            <div @click="faqIndex===item.id ? faqIndex=null : faqIndex=item.id"
                 :class="{'border border-yellow-400': faqIndex===item.id  }"
                 class="border border-gray-300 cursor-pointer rounded-full sm:p-3 p-1 justify-between flex">

              <div class="flex items-center">
                <span class="material-icons text-green-600">help</span>
                <h2 class="ml-3 break-words text-justify text-[11pt]">{{ item.question }}</h2>
              </div>

              <div class="sm:mr-4">
                <span v-if="faqIndex===item.id" class="material-icons">keyboard_arrow_up</span>
                <span v-else class="material-icons">expand_more</span>
              </div>
            </div>

            <div v-show="faqIndex===item.id" class="sm:p-5 p-2 mt-2 border border-gray-300 sm:mx-4 rounded-lg transition">
              <p class="ml-3 break-words text-justify" v-html="item.answer"></p>
            </div>
          </div>
        </div>
      </article>

      <div v-if="hotlinks.length" class="text-center place-items-center mt-12 sm:mt-20 mx-2 sm:mx-auto max-w-screen-xl relative">
        <div class="px-2 py-2 bg-green-500 text-white border w-64 rounded-full text-xl mx-auto absolute z-10 -top-8 inset-x-0 my-4">
          Find a trainer
        </div>
        <div class="rounded-2xl shadow-xl bg-white sm:p-9 p-2 pt-9 border mt-10 max-w-screen-xl flex flex-wrap">
          <div v-for="(link,key) in hotlinks"
               :key="key"
               class="rounded-2xl px-2 py-2 border border-gray-200 mt-1 shadow-md m-2 hover:shadow-xl transition duration-500 ease-in-out">
            <Link :href="`${link.href}`"
                  class="hover:text-indigo-500">
              {{ link.title }}
            </Link>
          </div>
        </div>
      </div>
    </main>

    <Footer/>
  </div>
</template>

<script>
import Select from "@/Jetstream/Select";
import Button from "@/Jetstream/Button";
import myMixin from "@/myMixin";
import Header from "@/Pages/Components/Header";
import Footer from "@/Pages/Components/Footer";
import {Link, InertiaHead} from '@inertiajs/inertia-vue3'
import {Inertia} from '@inertiajs/inertia';
import Loading from "@/Jetstream/Loading";

export default {
  name: "Index",
  mixins: [myMixin],
  props: {
    categories: Array,
    options: Array,
    faqs: Array,
    seo: Object,
    canonicalLink: String,
    hotlinks:Array
  },
  components: {Footer, Button, Select, Header, Link, InertiaHead, Loading},
  data() {
    return {
      userRegisterGoogleAds: this.$page.props.google_ads_user_register,
      navigation: null,
      showAllService: false,
      faqIndex: null,
      categorySelected: null,
      price: null,
      loading: false,
    }
  },
  methods: {
    updateNavigation(e) {
      this.navigation = e
    },
    toMaster() {
      // let mainCategory = this.$page.props.category;
      // if(this.categorySelected == mainCategory.url){
      //   return this.$inertia.get(`/${mainCategory.url}/online`);
      // }
      // return this.$inertia.get(`/${mainCategory.url}/${this.categorySelected}`);
      this.$inertia.get(`/${this.categorySelected}/online${this.price ? '?price=' + this.price : ''}`)
    },
    isMobile() {
      if (process.browser && typeof navigator !== "undefined") {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          return true
        } else {
          return false
        }
      }

      return false
    }
  },
  mounted() {
    // add for google ads user register from top menu link
    window.onpopstate = function (event) {
      var elem = document.getElementById("google_ads_user_register_from_sign_up");
      elem.parentNode.removeChild(elem);
    };

    Inertia.on('start', event => {
      this.loading = true
    });

    Inertia.on('finish', event => {
      this.loading = false
    })
  },
}
</script>

<style>
/* p {
    text-align: justify !important;
} */
</style>
